/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { FocusArea } from '../../../enums/generated/focus-area';
import { LegalSkill } from '../../../enums/generated/legal-skill';

export const opportunitySearchDigitalIntakeResultDtoSchema = z.object({ "focusAreas": z.array(z.nativeEnum(FocusArea)), "legalSkills": z.array(z.nativeEnum(LegalSkill)) });
export type OpportunitySearchDigitalIntakeResultDto = z.infer<typeof opportunitySearchDigitalIntakeResultDtoSchema>;
